import { DATA_PCR_LN_MODEL , getBaseURLforBackEnd , getConfigAxios  }  from '@/utils.js'
import axios from "axios";

export default {
    namespaced: true,

    state: {
        doneFetching : false,
        buffDatPrepareDat : "",
        buffDatCtDat : "",
        dataPCRSpecLN: Object.assign( {} ,DATA_PCR_LN_MODEL) ,
    },

    getters: {

    },

    mutations: {
        setDoneFetching (state, doneFetching) {
            state.doneFetching = doneFetching
        },

        setDataPCRSpecLN (state, dataPCRSpecLN) {
            state.dataPCRSpecLN = dataPCRSpecLN
        },

        setBuffDatPrepareDat (state, buffDatPrepareDat) {
            state.buffDatPrepareDat = buffDatPrepareDat
        },

        setBuffDatCtDat (state, buffDatCtDat) {
            state.buffDatCtDat = buffDatCtDat
        },

    },

    actions: {
        produceDoneFetching({commit},doneFetching){
            commit('setDoneFetching', doneFetching)
        },

        produceBuffDatPrepareDat({commit},buffDatPrepareDat){
            commit('setBuffDatPrepareDat', buffDatPrepareDat)
        },

        produceBuffDatCtDat({commit},buffDatCtDat){
            commit('setBuffDatCtDat', buffDatCtDat)
        },

        fetchPCROLDDat({commit},datTo) {
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem("access_token")}`
                axios.post(`${getBaseURLforBackEnd()}/api/labpcr_spec_opdno_spec_ln`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log(res.data)
                        commit('setDataPCRSpecLN', res.data)
                        // const  tmp = res.data.dat_prepare.dat
                        // console.log(tmp)
                        // buffer.from("SGVsbG8gVmlzaGFsIFRoYWt1cg==", 'base64').toString('ascii')
                        if(res.data.dat_prepare.dat === null){
                            commit('setBuffDatPrepareDat',"")
                        }else{
                            commit('setBuffDatPrepareDat', Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8') )
                        }
                        // **************************************************
                        if(res.data.dat_ct.dat === null){
                            commit('setBuffDatCtDat',"")
                        }else{
                            commit('setBuffDatCtDat', Buffer.from(res.data.dat_ct.dat, 'base64').toString('utf-8') )
                        }


                        // console.log( Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8'))
                        resolve(res.data)
                    })
            })
        }
    }
}